export const getElementContainerFlexes = (element) => {
  const containerEl = element.parentElement;
  const children = Array.from(containerEl.children);
  const flexes = children
    .filter((el) => el.className.includes('reflex-element'))
    .map((el) => el.style.flexGrow);
  return flexes;
};
